import React from 'react';
import './FaqPage.css';
import { motion, Variants, easeOut } from 'framer-motion';
import { Trans, useTranslation } from 'react-i18next'; // 1. Imports
import faqHero from '../../../assets/faq-hero.png';

interface FaqItem {
  id: number;
  question: string;
  answer: string;
}

const fadeInVariants: Variants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: easeOut,
      staggerChildren: 0.1,
    },
  },
};

const cardVariants: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0 },
};

const FaqPage: React.FC = () => {
  // 2. Hook
  const { t } = useTranslation();

  // 3. Obtenemos el array del JSON
  const faqs = t('faqPage:questions', { returnObjects: true }) as FaqItem[] | undefined;
  const safeFaqs = Array.isArray(faqs) ? faqs : [];

  return (
    <div className="faq-page-container">
      {/* --- Hero Section --- */}
      <header
        className="faq-hero"
        style={{ backgroundImage: `url(${faqHero})` }}
      >
        <div className="hero-overlay"></div>
        <motion.h1
          className="faq-hero-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3, ease: easeOut }}
        >
          <Trans i18nKey="faqPage:title" />
        </motion.h1>
      </header>

      {/* --- Questions Grid Section --- */}
      <motion.section
        className="faq-questions-section"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={fadeInVariants}
      >
        <motion.div className="faq-grid" variants={fadeInVariants}>
          {safeFaqs.map((faq, index) => (
            <motion.div key={index} className="faq-card" variants={cardVariants}>
              <h2 className="faq-question-title">
                {/* Mantenemos el número correlativo visualmente */}
                {index + 1}. {faq.question}
              </h2>
              
              <div className="faq-answer-text">
                {/* En lugar de split('\n'), usamos Trans para interpretar 
                   el <br/> que pusimos en el JSON 
                */}
                <Trans 
                   // Nota: Como estamos dentro de un map y faq.answer es un string directo,
                   // aquí es mejor usar defaults (contenido) en lugar de i18nKey dinámico,
                   // O simplemente renderizar el HTML si confiamos en el JSON.
                   // La forma más segura con i18next dentro de un loop de objetos es
                   // usar el componente Trans con el contenido por default:
                   defaults={faq.answer}
                   components={{ br: <br /> }}
                />
              </div>
            </motion.div>
          ))}
        </motion.div>
      </motion.section>
    </div>
  );
};

export default FaqPage;